if (!customElements.get('te-product-details')) {
  customElements.define(
    'te-product-details',
    class TeProductDetails extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.reviewLink = document.querySelector(
          `[data-te-review-link="${this.dataset.sectionId}"]`
        );

        this.onReviewLinkClick = this.openReviews.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab, true));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
        });

        if (this.reviewLink) {
          this.reviewLink.addEventListener('click', this.onReviewLinkClick);
        }

        this.dataset.initialized = 'true';
      }

      disconnectedCallback() {
        if (this.reviewLink && this.onReviewLinkClick) {
          this.reviewLink.removeEventListener('click', this.onReviewLinkClick);
        }
      }

      activateTab(activeTab, moveFocus = false) {
        const target = activeTab.dataset.teTab;

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tePanel !== target;
        });

        if (moveFocus) activeTab.focus({ preventScroll: true });
      }

      openReviews(event) {
        event.preventDefault();

        const reviewTab = this.querySelector('[data-te-tab="reviews"]');
        const reviewAccordion = this.querySelector('[data-te-review-accordion]');

        if (reviewTab) this.activateTab(reviewTab, false);
        if (reviewAccordion) reviewAccordion.open = true;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.requestAnimationFrame(() => {
          this.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      }

      handleKeydown(event, currentTab) {
        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }
    }
  );
}
